import ru from '@/locales/ru.json'

const constants = {
  request_exams_status: {
    NEW: 'new',
    REVIEW_AUTH_ORG: 'review_auth_org',
    REVISION_AUTH_ORG: 'revision_auth_org',
    REVIEW_DE_DEPARTMENT: 'review_de_department',
    REVISION_DE_DEPARTMENT: 'revision_de_department',
    AGREED_DE_DEPARTMENT: 'agreed_de_department'
  },
  exam_status: {
    AGREED_DE_DEPARTMENT: 'agreed_de_department',
    CONFIRMED_AUTH_ORG: 'confirmed_auth_org',
    CONFIRMED_AUTH_ORG_BLOCKED: 'confirmed_auth_org_blocked',
    APPROVED_MAIN_EXPERT: 'approved_main_expert',
    APPROVED_MAIN_EXPERT_BLOCKED: 'approved_main_expert_blocked',
    COMPLETE_MAIN_EXPERT: 'complete_main_expert',
    COMPLETE_MAIN_EXPERT_BLOCKED: 'complete_main_expert_blocked'
  },
  exam_blocked_status: {
    CONFIRMED_AUTH_ORG_BLOCKED: 'confirmed_auth_org_blocked',
    APPROVED_MAIN_EXPERT_BLOCKED: 'approved_main_expert_blocked',
    COMPLETE_MAIN_EXPERT_BLOCKED: 'complete_main_expert_blocked'
  },
  exam_flags: {
    UNIVERSITY: 'university_degree',
    TOTAL: 'total',
    INTERMEDIATE: 'intermediate',
    SPO: 'secondary_degree',
    COMMERCIAL: 'commercial_exam',
    CORPORATE: 'corporate',
    DKE: 'voluntary_qualify_exam',
    MPO: 'master_of_industrial_edu',
    FIFTY_PLUS: '50_plus',
    INDEPENDENT_ESTIMATE: 'independent_estimate',
    FGOS: 'state_standard',
    NOT_FGOS: 'not_state_standard',
    GIA: 'state_final_attestation',
    VUZ: 'university',
    REGIONAL: 'regional_exam',
    PROFESSIONAL_EDUCATION: 'professional_education',
    JUNIORS: 'juniors',
    REMOTE_EXPERTS: 'remote_experts',
    REMOTE_MEMBERS: 'remote_members'
  },
  ALL: ['*', '<.*>'],
  NULL_GUID: '00000000-0000-0000-0000-000000000000',
  COMPEXITY_LEVELS: [
    '1.1',
    '1.1-2022-2024',
    '1.1-2023-2025',
    '1.2',
    '1.2-2022-2024',
    '1.2-2023-2025',
    '1.3',
    '1.3-2022-2024',
    '1.3-2023-2025',
    '1.4',
    '1.4-2022-2024',
    '1.4-2023-2025',
    '1.5',
    '1.5-2022-2024',
    '1.5-2023-2025',
    '1.6',
    '1.6-2022-2024',
    '1.6-2023-2025',
    '1.7',
    '1.7-2022-2024',
    '1.7-2023-2025',
    '1.8',
    '1.8-2022-2024',
    '1.9',
    '1.9-2022-2024',
    '1.10',
    '1.10-2022-2024',
    '2.1',
    '2.1-2022-2024',
    '2.1-2023-2025',
    '2.1.141-2023',
    '2.1.15-2023',
    '2.1.17-2023',
    '2.1.214-2023',
    '2.1.231-2023',
    '2.1.235-2023',
    '2.1.276-2023',
    '2.1.278-2023',
    '2.1.291-2023',
    '2.1.299-2023',
    '2.1.302-2023',
    '2.1.309-2023',
    '2.1.34-2023',
    '2.1.68-2023',
    '2.1.84-2023',
    '2.2',
    '2.2-2022-2024',
    '2.2-2023-2025',
    '2.2.141-2023',
    '2.2.15-2023',
    '2.2.17-2023',
    '2.2.214-2023',
    '2.2.231-2023',
    '2.2.235-2023',
    '2.2.276-2023',
    '2.2.278-2023',
    '2.2.291-2023',
    '2.2.299-2023',
    '2.2.302-2023',
    '2.2.309-2023',
    '2.2.34-2023',
    '2.2.84-2023',
    '2.3',
    '2.3-2022-2024',
    '2.3.141-2023',
    '2.3.214-2023',
    '2.3.235-2023',
    '2.3.291-2023',
    '2.3.309-2023',
    '2.4',
    '2.4.141-2023'
  ]
}

export const EXAM_DEFAULT_VALUES = {
  name: {
    translate: {
      ru: ''
    }
  },
  de_center: {
    guid: null,
    name: {
      display: '',
      translate: {
        ru: ''
      }
    }
  },
  accred_comps: {
    number: null,
    competency: {
      code: '',
      guid: null,
      name: {
        display: '',
        translate: {
          ru: ''
        }
      }
    },
    status: null,
    complexity_level: null
  },
  guid: null,
  day_cm1: null,
  started_at: null,
  ended_at: null,
  flags: [constants.exam_flags.SPO, constants.exam_flags.FGOS],
  complexity_level: null,
  status: 'new',
  remote_experts: false,
  remote_members: false,
  experts: [],
  main_expert: null
}

export const APPLICATION_TYPES = {
  INTERMEDIATE: 'intermediate',
  TOTAL: 'total',
  FINAL: 'state_final_attestation'
}

export const LEVEL_TYPES = {
  BASIC: 'de_level_basic',
  INTERMEDIATE_CERT: 'de_level_intermediate_certification',
  PROF_SKILL: 'de_level_prof_skill',
  VARIANT: 'de_level_variant'
}

export const FLAGS = {
  ...APPLICATION_TYPES,
  ...LEVEL_TYPES,
  REMOTE_EXPERTS: 'remote_experts',
  REMOTE_MEMBERS: 'remote_members'
}

export const TYPES_SCHEMA = [
  [
    {
      title: ru.flags.intermediate.title,
      subtitle: ru.flags.intermediate.subtitle,
      value: APPLICATION_TYPES.INTERMEDIATE
    },
    {
      title: ru.flags.total.title,
      subtitle: ru.flags.total.subtitle,
      value: APPLICATION_TYPES.TOTAL
    },
    {
      title: ru.flags.state_final_attestation.title,
      subtitle: ru.flags.state_final_attestation.subtitle,
      value: APPLICATION_TYPES.FINAL
    }
  ]
]

export const LEVEL_SCHEMA = [
  { title: 'Базовый уровень', value: LEVEL_TYPES.BASIC },
  { title: 'Профильный уровень', value: LEVEL_TYPES.PROF_SKILL },
  { title: 'Профильный уровень (вариативная часть)', value: LEVEL_TYPES.VARIANT }
]

export const ERRORS_MESSAGES = {
  exam_ended_at: 'Между датой начала и датой окончания больше 2 дней',
  exam_started_at: 'Между датой начала и датой ПД больше 1 дня',
  exam_current_year: 'Дата относится к другому году',
  exam_job_issued_at: 'Между датой выдачи задания и датой начала больше 1 дня'
}

export const MESSAGE_EXAM_KEYS = {
  started_at: 'exam_started_at',
  ended_at: 'exam_ended_at',
  job_issued_at: 'exam_job_issued_at'
}

export { constants }
